import moment from 'moment'
// 現在時刻のミリ秒の数値を返す
const currentMillis = () => (Number(moment().format('SSS')));

// localStrageのキー
const windowSeqKey = 'KuraemonCloud2-windowSeq'

// クライアント側で作るキーは36進数(00～zz, 0000～zzzz)表現にする
const radix = 36;
const maxWindowSeq = parseInt("zz", radix);
const maxPhotoKeySeq = parseInt("zzzz", radix);
const formatKeyNum = (n, padding = 2) => (n.toString(radix).padStart(padding, '0'));

const set = property => (state, payload) => (state[property] = payload)
const get = property => (state) => (state[property])

export default {
  namespaced: true,
  state: {
    // サーバーサイドから取得するキー
    clientKeyPrefix: '',
    // ウィンドウ単位のキー・・・画面を開く毎に初期化する(localStrageから取得する連番を含む)
    windowId: undefined,
    // key発行毎の連番(store内でincrement)
    keySeq: 0,
  },
  getters: {
    clientKeyPrefix: get('clientKeyPrefix'),
    windowId: get('windowId'),
    keySeq: get('keySeq'),
  },
  mutations: {
    setClientKeyPrefix: set('clientKeyPrefix'),
    setWindowId: set('windowId'),
    setKeySeq: set('keySeq'),
  },
  actions: {
    // ウィンドウ単位のキーを初期化する
    initWindowId({ commit, getters }){
      if(getters.windowId) return; // 初期化済み

      const cur = localStorage.getItem(windowSeqKey)
      const curWindowSeq = (cur ? Number(cur) : 0) % maxWindowSeq; // ※数値は最大値で循環する
      localStorage.setItem(windowSeqKey, curWindowSeq + 1); // increment

      const curMillis = currentMillis(); // ※現在時刻のミリ秒数値を末尾に付与する
      const windowId = `${ formatKeyNum(curWindowSeq) }${ formatKeyNum(curMillis) }`

      commit("setWindowId", windowId)
    },
    // サーバーサイドから取得するキーを更新する
    updateClientKeyPrefix({ commit }, clientKeyPrefix){
      commit("setClientKeyPrefix", clientKeyPrefix)
    },
    // 現在のkeyを返す
    currentKey({ commit, getters }, { itemType }){
      const clientKeyPrefix = getters.clientKeyPrefix;
      if(!clientKeyPrefix) throw new Error("clientKeyPrefixが設定されていない")
      const windowId = getters.windowId;
      if(!windowId) throw new Error("windowIdが設定されていない")

      const curKeySeq = getters.keySeq % maxPhotoKeySeq; // ※数値は最大値で循環する
      commit("setKeySeq", curKeySeq + 1); // increment

      const curKey = formatKeyNum(curKeySeq, 4)

      const typePrefix = (() => {
        if(itemType === 'photo') return 'p1';
        if(itemType === 'kokuban') return 'k1';
        if(itemType === 'formInputId') return 'input_id_v1';
        if(itemType === 'formOptionValue') return 'option_value_v1';
        if(itemType === 'camViewer') return 'cam_viewer_v1';
        return '';
      })()

      return `${ typePrefix }_${ clientKeyPrefix }_${ windowId }${ curKey }`
    },
  },
}
